var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FacebookComp",
    clipPath: "url(#clip0_841_4410)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1336 19.7628H23.1336L24.7336 12.8888H19.1336V9.45179C19.1336 7.68173 19.1336 6.01477 22.3336 6.01477H24.7336V0.240591C24.212 0.166695 22.2424 0 20.1624 0C15.8184 0 12.7336 2.84757 12.7336 8.07698V12.8888H7.93359V19.7628H12.7336V34.3701H19.1336V19.7628Z",
    fill: "#FFFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_4410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 34.3701,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.aa6449216022b549053b67963a0af739.svg";
export { ForwardRef as ReactComponent };